import { Button } from 'react-bootstrap';

function ResetMobileOrderDisplayDemo() {
  function handleClick() {
    console.log(1);
  }

  return (
    <div>
      <Button onClick={handleClick}>Reset Mobile Order Display</Button>
    </div>
  );
}

export default ResetMobileOrderDisplayDemo;
